import {DetailHeaderContent} from '../../../components/DetailHeader/DetailHeaderContent'
import {BookingModel} from '../../../models/ems/BookingModel'
import {useBookingDataUtils} from '../hooks/useBookingDataUtils'
import {DataButton} from '../../../components/inputs/DataButton'
import {bookingIsCancellable} from './tables/BookingTable/BookingTableActions'
import {MetronicIcon} from '../../../components/inputs/MetronicIcon'
import {BookingStatusColumn} from './tables/BookingTable/BookingStatusColumn'
import {DateFormatter} from '../../../components/utils/formatter/DateFormatter'

export interface CustomerBookingDetailsHeaderProps {
  booking?: BookingModel | null
  onRefresh?: () => void
  onRefreshCallback?: () => void
}

export const CustomerBookingDetailsHeader = ({
  onRefresh,
  booking,
  onRefreshCallback,
}: CustomerBookingDetailsHeaderProps) => {
  const {cancelSingle, isBookingLoading} = useBookingDataUtils({onRefresh, onRefreshCallback})

  return (
    <>
      <DetailHeaderContent
        left={
          <div className='d-flex flex-row'>
            <div className='d-flex flex-column px-2'>
              <div className='d-flex flex-wrap'>
                <div className='d-flex flex-column mt-3'>
                  {booking && (
                    <>
                      <div className='d-flex flex-wrap'>
                        <span className='me-1 fw-bolder'>Booking:</span>
                        <span className='me-1'>{booking.code}</span>
                      </div>
                      <div className='d-flex flex-wrap'>
                        <span className='me-1 fw-bolder'>Status:</span>
                        <BookingStatusColumn data={booking} />
                      </div>

                      <div className='d-flex flex-wrap'>
                        <span className='me-1 fw-bolder'>Date:</span>
                        <DateFormatter className='text-uppercase'>
                          {booking.updatedAt}
                        </DateFormatter>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        }
        right={
          <div className='d-flex my-4 flex-wrap'>
            {booking && (
              <>
                {bookingIsCancellable(booking) && (
                  <DataButton
                    disabled={isBookingLoading(booking)}
                    onClick={cancelSingle}
                    data={booking}
                    className='min-w-125px'
                    variant='text'
                    color='danger'
                  >
                    <MetronicIcon iconType='Code' iconName='Stop' />
                    Cancel
                  </DataButton>
                )}
              </>
            )}
          </div>
        }
      />
    </>
  )
}
